/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { ProductConstants } from '../actions/actionType';

export function Cart(state = {}, action) {
    switch (action.type) {
    case ProductConstants.GET_CART_LIST_SUCCESS:
        return {
            type: ProductConstants.GET_CART_LIST_SUCCESS,
            items: action.user.data.data.cart_items,
            summary:action.user.data.data.summary
        };
    case ProductConstants.GET_CART_LIST_FAILURE:
        return {
            type: ProductConstants.GET_DISTRIBUTORS_FAILURE,
            message: action.message,
            items:[]
        };
    case ProductConstants.GET_CART_SELECTED_ITEM:
        return {...state,
            selected:action.user.data
                
        };
        
    default:
        return state;
    }
}
